import { useTranslation } from 'react-i18next'
import { PaymentSummaryDetails as _PaymentSummaryDetails } from '@jagad/ui'
import type { PaymentSummaryDetailsProps as _PaymentSummaryDetailsProps } from '@jagad/ui'

type PaymentSummaryDetailsProps = Omit<
  _PaymentSummaryDetailsProps,
  | 'accountDetailsLabel'
  | 'amountDetailsLabel'
  | 'accountLabel'
  | 'amountLabel'
  | 'customerNameLabel'
  | 'powerLabel'
  | 'meterNoLabel'
  | 'adminFeeLabel'
  | 'platformFeeLabel'
  | 'jidrPaidLabel'
> & {
  paymentType?: 'Top up' | 'Bill'
}

export default function PaymentSummaryDetails({
  accountType = 'account',
  paymentType = 'Bill',
  ...props
}: PaymentSummaryDetailsProps) {
  const { t } = useTranslation()

  const accountLabel = accountType === 'phone'
    ? t('paymentSummary.phoneNumber')
    : t('paymentSummary.accountNumber')

  const amountLabel = paymentType === 'Top up'
    ? t('paymentSummary.topUpAmount')
    : t('paymentSummary.billAmount')

  return (
    <_PaymentSummaryDetails
      {...props}
      accountType={accountType}
      accountDetailsLabel={t('paymentSummary.accountDetails')}
      amountDetailsLabel={t('paymentSummary.amountDetails')}
      accountLabel={accountLabel}
      amountLabel={amountLabel}
      customerNameLabel={t('paymentSummary.customerName')}
      powerLabel={t('paymentSummary.power')}
      meterNoLabel={t('paymentSummary.meterNo')}
      adminFeeLabel={t('paymentSummary.adminFee')}
      platformFeeLabel={t('paymentSummary.platformFee')}
      jidrPaidLabel={t('paymentSummary.jidrPaid')}
    />
  )
}
